<!--
 * Path: src/core/components/floatingPanel/FloatingPanelFooter.vue
 * Task: Renders a structured panel footer styled to match the dark translucent acrylic theme.
-->
<template>
  <div
    class="panel-footer px-4 py-2 d-flex align-center justify-space-between text-caption text-grey-lighten-1"
    style="border-top: 1px solid rgba(255, 255, 255, 0.1); background-color: rgba(255, 255, 255, 0.03);"
  >
    <slot>
      <span>{{ itemCount }} {{ itemCount === 1 ? 'Item' : 'Items' }}</span>
    </slot>
  </div>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/floatingPanel/FloatingPanelFooter.vue
 * Task: Panel footer component tracking reactive item counts.
 */
interface Props {
  itemCount?: number;
}

withDefaults(defineProps<Props>(), {
  itemCount: 0
});
</script>
